import React from 'react';
import LegalPage, { ExternalLink, LegalList, LegalListItem } from './LegalPage';

export default function DataProcessing() {
  return (
    <LegalPage title="Datenverarbeitung">
      <LegalList ordered>
        <LegalListItem>
          Die Verarbeitung personenbezogener Daten des Nutzers erfolgt auf Grundlage der Datenschutz-Grundverordnung Nr
          2016/679 (DS-GVO) sowie der anwendbaren nationalen Datenschutznormen.
        </LegalListItem>
        <LegalListItem>
          Sofern der Nutzer eine Immobilie über den Wohnrechner bewerten lässt, werden die von ihm zu diesem Zweck auf
          der Plattform angegebenen Daten (Name, E-Mail Adresse und Objektdaten) von HYPO NOE ohne weitergehende
          Einwilligung zur Durchführung der Bewertung und Zurverfügungstellung des Bewertungsergebnisses, für die
          Berechnung eines Haushaltsbudgets, für die Erstellung eines Überblick für die Finanzierbarkeit der geplanten
          Immobilie und eines Richtwerts für die Kosten des geplanten Immobilienprojekts (gem. Art. 6 Abs. 1 lit. b
          DS-GVO) verarbeitet. Weiters erfolgt die Verarbeitung zur Wahrung berechtigter Interessen des Anbieters bzw
          Dritter (Art 6 Abs 1 lit f DS-GVO), insbesondere auch zu Zwecken der Betriebssicherheit der
          Webseite/Plattform, des Forderungsmanagements, des Direktmarketings in analoger und digitaler Form, der
          Bestandskundenwerbung, der statistischen Auswertung sowie der Verbesserung des Dienstleistungsangebots und
          dessen Qualität.
        </LegalListItem>
        <LegalListItem>
          Die folgenden personenbezogenen Daten die Person des Nutzers betreffend können im Zusammenhang mit der
          Einrichtung eines User-Accounts infolge der Eingabe des Nutzers vom Verantwortlichen erhoben und verarbeitet
          werden: (i) Vor- und Nachname / Firma, (ii) Adresse, (iii) Email-Adresse, (iv) Bankverbindung /
          Zahlungsinformationen, (v) UID-Nummer.
        </LegalListItem>
        <LegalListItem>
          Durch den Aufruf oder die Nutzung der Plattform können weiters die folgenden (teilweise personenbezogenen)
          Daten an den Verantwortlichen übermittelt und von diesem verarbeitet werden: (i) Logdateien wie IP-Adresse,
          Datum und Uhrzeit des Aufrufs, Informationen über das verwendete Betriebssystem und den Internet-Browser,
          Website, von der aus der Zugriff erfolgt („Referrer-URL“) etc (ii) Cookies, (iii) standortbezogene
          Informationen und Informationen über das verwendete Endgerät (abhängig von den entsprechenden Einstellungen
          des Endgeräts).
        </LegalListItem>
        <LegalListItem>
          Diese Website verwendet ausschließlich technisch notwendige Session-Cookies, die für den sicheren und
          ordnungsgemäßen Betrieb der Website erforderlich sind. Eine Deaktivierung dieser Cookies ist nicht möglich, da
          die Website andernfalls nicht ordnungsgemäß funktionieren würde. Es werden keine Analyse-, Tracking- oder
          Marketing-Cookies eingesetzt.
        </LegalListItem>
        <LegalListItem>
          Eine Weitergabe personenbezogener Daten an Dritte erfolgt nicht (bzw ausschließlich im Rahmen der
          Vertragserfüllung nach den Vorgaben der DS-GVO (siehe Punkt 15.) bzw nach einer vorherigen gesonderten
          Zustimmung).
        </LegalListItem>
        <LegalListItem>
          Der Schutz personenbezogener Nutzer-Daten erfolgt durch organisatorische und technische Maßnahmen, wie etwa
          dem Schutz vor unberechtigtem Zugriff, Beeinträchtigung oder Verlust und technische
          Datensicherheitsvorkehrungen.
        </LegalListItem>
        <LegalListItem>
          Personenbezogene Daten werden vom Verantwortlichen nur so lange aufbewahrt, wie dies zur Erfüllung
          vertraglicher bzw gesetzlicher Verpflichtungen notwendig ist (entsprechende Aufbewahrungspflichten können sich
          zB insbesondere aus steuerrechtlichen Vorschriften ergeben – eine Rechtsgrundlage für die Aufbewahrung der
          Daten ergibt sich in diesem Zusammenhang auch aus Art 6 Abs 1 lit c DS-GVO). Ist diese Erforderlichkeit nicht
          mehr gegeben, werden die Daten gelöscht.
        </LegalListItem>
        <LegalListItem>
          Vorbehaltlich des Bestehens allfälliger gesetzlicher Verschwiegenheitsverpflichtungen hat der Nutzer die
          folgenden Rechte:
          <LegalList>
            <LegalListItem>
              Das Recht, jederzeit Auskunft über seine gespeicherten personenbezogenen Daten, deren Herkunft, den
              Verarbeitungszweck sowie gegebenenfalls den Empfänger dieser Daten zu erhalten (Art 15 DS-GVO).
            </LegalListItem>
            <LegalListItem>
              Das Recht, die Berichtigung, Übertragung, Einschränkung der Bearbeitung, Sperrung oder Löschung der
              personenbezogenen Daten zu verlangen, wenn diese unrichtig sind oder die Grundlage für die
              Datenverarbeitung wegfällt (Art 16, 17, 18, 20 DS-GVO).
            </LegalListItem>
            <LegalListItem>
              Das Recht, Widerspruch gegen die Verarbeitung personenbezogener Daten auf Basis von Art 6 Abs 1 lit f
              DS-GVO („Wahrung berechtigter Interessen“) zu erklären (Art 21 DS-GVO). Es wird jedoch darauf hingewiesen,
              dass ein allfälliger Widerspruch keinen Einfluss auf die Zulässigkeit der Verarbeitung personenbezogener
              Daten auf Basis sonstiger Erlaubnistatbestände nach Art 6 Abs 1 DS-GVO hat.
            </LegalListItem>
          </LegalList>
        </LegalListItem>
        <LegalListItem>
          Nutzer können diese Ansprüche an folgende E-Mail-Adresse richten:{' '}
          <a href="mailto:datenschutz@hyponoe.at">datenschutz@hyponoe.at</a>
        </LegalListItem>
        <LegalListItem>
          Sollte ein Nutzer der Ansicht sein, dass die Verarbeitung seiner personenbezogenen Daten gegen geltende
          datenschutzrechtliche Bestimmungen verstößt oder seine Ansprüche nach dem Datenschutzrecht in sonstiger Weise
          verletzt worden sind, hat er das Recht, eine Beschwerde bei der zuständigen Aufsichtsbehörde (gemäß Art 77
          DS-GVO) einzubringen.
        </LegalListItem>
        <LegalListItem>
          Weitere Informationen zur Datenverarbeitung von HYPO NOE als Verantwortlicher erhalten Nutzer unter{' '}
          <ExternalLink href="https://www.hyponoe.at/datenschutz">www.hyponoe.at/datenschutz</ExternalLink>.
        </LegalListItem>
        <LegalListItem>
          Für die Berechnung des Schätzwertes (Vertragserfüllung) wird von HYPO NOE ein von der DSS betriebenes Tool
          (Sprengnetter) verwendet. Zu diesem Zweck werden die vom Nutzer bekanntgegebenen Objektdaten (Art der
          Immobilie, Adresse/Adresskoordinaten, Zustand des Gebäudes, Grundstücksfläche, Wohnfläche, ggf. Widmung
          (Grundstück), Baujahr und Ausstattungsmerkmale (Terrasse, Lift etc…)), über eine Schnittstelle an die DSS,
          weitergegeben, soweit die Weitergabe zur Bewertung erforderlich ist. Rechtsgrundlage für die Weitergabe der
          Daten ist (soweit personenbezogene Daten betroffen sind) Art. 6 Abs. 1 lit. b DS-GVO.
        </LegalListItem>
        <LegalListItem>
          Nähere Informationen zum Datenschutz von DSS als für die Datenverarbeitung im Rahmen der Berechnung des
          Schätzwertes Verantwortlicher finden Nutzer unter{' '}
          <ExternalLink href="https://www.sprengnetter.at/datenschutz/">
            https://www.sprengnetter.at/datenschutz/
          </ExternalLink>
        </LegalListItem>
        <LegalListItem>
          Die vom Nutzer auf der Plattform eingegebenen Objektdaten können von der DSS weiterverwendet werden. Der
          Nutzer räumt mit der Übermittlung/Zurverfügungstellung der DSS unentgeltlich das nicht-exklusive, zeitlich,
          räumlich und inhaltlich unbeschränkte Recht ein, diese Objektdaten auf sämtliche gegenwärtig und künftig
          bekannte Nutzungsarten in allen Medien in beliebiger Verfahrensart und Anzahl zu verwenden. Dies beinhaltet
          insbesondere, aber nicht ausschließlich, das Recht, diese Objektdaten (und/oder Teile davon) zu
          vervielfältigen, zu speichern, zu verbreiten, zu vermieten/verleihen, darzustellen, zu senden, öffentlich
          wiederzugeben und aufzuführen, der Öffentlichkeit (drahtlos oder drahtgebunden) zur Verfügung zu stellen sowie
          mit Werken gleicher oder anderer Art zu verbinden (synchronisieren), allumfassend zu bearbeiten, anzupassen
          und zu kürzen, zu teilen und zu verändern und diese Bearbeitungen auf die vorgenannten Arten zu verwenden. Es
          umfasst insbesondere auch die Verwendung zur Verbesserung der Plattform oder der zugrundeliegenden
          statistischen Modelle.
        </LegalListItem>
      </LegalList>
    </LegalPage>
  );
}
